import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginGuardService } from '@tango/app/core/services';
import { BankLoginComponent } from './login.component';

const routes: Routes = [
  {
    path: 'login',
    component: BankLoginComponent,
    canActivate: [LoginGuardService],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoginRoutingModule {}
